import React, {useState} from 'react';
import {PRISMAX_ADMIN_DOWNLOADS_URL} from '../../configs/config';
import styles from './EpisodeRejectionModal.module.css';

export default function EpisodeRejectionModal({episode, upload, adminToken, onClose, onRejected}) {
    const targetPath = upload ? `uploads/${upload.upload_id}` : `episodes/${episode.episode_id}`;
    const [reason, setReason] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const submit = async (event) => {
        event.preventDefault();
        if (!reason.trim() || busy) return;
        setBusy(true);
        setError('');
        try {
            const response = await fetch(`${PRISMAX_ADMIN_DOWNLOADS_URL}/data/admin/${targetPath}/reject`, {
                method: 'POST',
                headers: {Authorization: `Bearer ${adminToken}`, 'Content-Type': 'application/json'},
                body: JSON.stringify({reason: reason.trim()}),
            });
            const result = await response.json().catch(() => ({}));
            if (response.status === 404) throw new Error('This rejection endpoint is not available yet. Please wait for the backend deployment and try again.');
            if (!response.ok || !result.success) throw new Error(result.msg || 'Could not reject episode.');
            onRejected(result.data);
        } catch (err) {
            setError(err instanceof TypeError
                ? 'Could not confirm the request. Refresh the upload status before trying again.'
                : (err.message || 'Could not reject episode.'));
            setBusy(false);
        }
    };
    return (
        <div className={styles.overlay}>
            <form className={styles.dialog} onSubmit={submit} role="dialog" aria-modal="true" aria-labelledby="episode-reject-title">
                <h2 id="episode-reject-title">{upload ? `Reject all episodes in ${upload.upload_label || `UPL-${upload.upload_id}`}` : `Reject episode ${episode.episode_id}`}</h2>
                <p>{upload
                    ? 'This permanently rejects every currently available episode in this upload, including episodes not shown on this page. The same reason is saved on each episode. Already rejected episodes keep their existing reason; processing or failed episodes are skipped. This cannot be restored.'
                    : 'This permanently removes this episode from available data and future downloads or deliveries. It cannot be restored.'}</p>
                <label htmlFor="episode-reject-reason">Reason (visible to the operator)</label>
                <textarea id="episode-reject-reason" autoFocus required maxLength={2000} value={reason} onChange={(e) => setReason(e.target.value)} disabled={busy} rows={5}/>
                {error && <p role="alert">{error}</p>}
                <div className={styles.actions}>
                    <button type="button" disabled={busy} onClick={onClose}>Cancel</button>
                    <button className={styles.reject} type="submit" disabled={busy || !reason.trim()}>{busy ? 'Rejecting…' : 'Permanently reject'}</button>
                </div>
            </form>
        </div>
    );
}
